<style scoped>
    .staff-card{
        margin: 4px 2px;
    }
    .title{
        /*background-color: #5cadff;*/
        background-color: #515a6e;
        font-size: 24px;
        color: white;
    }
    .wiki{
        font-size: 18px;
    }
</style>
<template>
  <div>
    <table class="mis-table">
      <tr>
        <td
          class="title"
          width="120"
        >
          <div class="title">
            付款
          </div>
          <div class="title">
            预支
          </div>
          <div class="title">
            报销
          </div>
        </td>
        <td>
          <StaffCard
            class="staff-card"
            :duty_height="55"
            :staff="staffs.gouling"
          />
          <StaffCard
            class="staff-card"
            :duty_height="55"
            :staff="staffs.licong"
          />
        </td>
        <td width="200">
          <ViewerItem
            class="wiki"
            type="Wiki"
            :model_id="9"
          >
            <div class="link">
              <Icon type="ios-bookmarks-outline" />
              财务流程综合指南
            </div>
          </ViewerItem>
        </td>
      </tr>
      <tr>
        <td class="title">
          <div class="title">
            合同
          </div>
        </td>
        <td>
          <StaffCard
            class="staff-card"
            :duty_height="72"
            :staff="staffs.tianya"
          />
          <StaffCard
            class="staff-card"
            :duty_height="72"
            :staff="staffs.yangjunzhen"
          />
          <StaffCard
            class="staff-card"
            :duty_height="72"
            :staff="staffs.miaohuizi"
          />
        </td>
        <td />
      </tr>
      <tr>
        <td class="title">
          <div class="title">
            其他财务支持
          </div>
        </td>
        <td>
          <div>
            <StaffCard
              class="staff-card"
              :duty_height="55"
              :staff="staffs.shixuefei"
            />
            <StaffCard
              class="staff-card"
              :duty_height="55"
              :staff="staffs.baiyanyu"
            />
            <StaffCard
              class="staff-card"
              :duty_height="55"
              :staff="staffs.maliangyan"
            />
          </div>
          <div>
            <StaffCard
              class="staff-card"
              :duty_height="55"
              :staff="staffs.yuhao"
            />
            <StaffCard
              class="staff-card"
              :duty_height="55"
              :staff="staffs.shuchang"
            />
            <StaffCard
              class="staff-card"
              :duty_height="55"
              :staff="staffs.luoyang"
            />
          </div>
          <StaffCard
            class="staff-card"
            :duty_height="55"
            :staff="staffs.cuihaowei"
          />
        </td>
        <td />
      </tr>
    </table>
    <!--<div class="line text-large">
            <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=2428390880&site=qq&menu=yes">
                <Icon type="chatbox-working"></Icon>
                财务客服 - 报销、付款类问题
            </a>
        </div>
        <div class="line text-large">
            <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=3477005568&site=qq&menu=yes">
                <Icon type="chatbox-working"></Icon>
                财务客服 - 其他问题
            </a>
        </div>
        <div class="hr"></div>
        <a class="text-bold" href="/static/各申请相关说明.pdf" target="_blank">各申请相关说明(点击下载PDF)</a>-->
  </div>
</template>
<script route="/mine/introduction">
  import StaffCard from '../fin/components/staff_card';
  import ViewerItem from '../components/viewer/item';
  export default {
    /* router_info_start */
    router_info:{
      path: '/mine/introduction',
      noChkout: true
    },
    /* router_info_end */

    components: { StaffCard, ViewerItem },
    data() {
      return {
        staffs: {
          gouling: {
            name: '苟玲',
            nickname: '苟玲老师',
            duty: '<p>付款申请、报销申请</p><p>银行回单查询</p>',
            time: '上午10点~下午5点',
            email: 'payment@baicizhan.com',
            qq: '2428390880',
            avatar: 'fin_photo/gouling.jpg',
            wechat_image: 'fin_photo/wechat/gouling.jpg'
          },
          licong: {
            name: '李聪',
            nickname: '聪哥',
            duty: '<p>付外汇、询问打款进度</p><p>财务部一切不知道问谁的问题</p>',
            time: '每天下午2点~5点',
            email: 'licong@baicizhan.com',
            qq: '3477005568',
            avatar: 'fin_photo/licong.jpg',
            wechat_image: 'fin_photo/wechat/licong.png'
          },
          tianya: {
            name: '田亚',
            nickname: '亚亚',
            duty: '<p>合同条款、盖章</p><p>知识产权相关问题</p>',
            time: '下午2点~4点',
            email: 'tianya@baicizhan.com',
            qq: '',
            avatar: 'fin_photo/tianya.jpg',
            wechat_image: 'fin_photo/wechat/tianya.jpg'
          },
          yangjunzhen: {
            name: '杨君真',
            nickname: '真善美',
            duty: '<p>非存货类合同的财务条款</p><p>(包括付款、开票等条款)</p><p>税务问题</p>',
            time: '下午2点~4点',
            email: 'yangjunzhen@baicizhan.com',
            qq: '',
            avatar: 'fin_photo/yangjunzhen.jpg',
            wechat_image: 'fin_photo/wechat/yangjunzhen.jpg'
          },
          miaohuizi: {
            name: '苗卉子',
            nickname: '阿喵',
            duty: '<p>存货类合同财务条款</p><p>存货类供应商对账</p><p>销售数据对账</p>',
            time: '下午2点~4点',
            email: 'miaohuizi@baicizhan.com',
            qq: '',
            avatar: 'fin_photo/miaohuizi.jpg',
            wechat_image: 'fin_photo/wechat/miaohuizi.jpg'
          },
          shixuefei: {
            name: '石雪飞',
            nickname: '石头姐',
            duty: '<p>存货代码申请</p><p>实习生外包工资发放</p>',
            time: '',
            email: 'sxf@baicizhan.com',
            qq: '',
            avatar: 'fin_photo/shixuefei.jpg',
            wechat_image: 'fin_photo/wechat/shixuefei.jpg'
          },
          baiyanyu: {
            name: '白严昱',
            nickname: '小白',
            duty: '<p>各团队业务数据收集</p>',
            time: '',
            email: 'sarah@baicizhan.com',
            qq: '',
            avatar: 'fin_photo/baiyanyu.jpg',
            wechat_image: 'fin_photo/wechat/baiyanyu.png'
          },
          maliangyan: {
            name: '马良焰',
            nickname: '良哥',
            duty: '<p>MIS系统开发和维护</p>',
            time: '',
            email: 'maly@baicizhan.com',
            qq: '',
            avatar: 'fin_photo/maliangyan.jpg',
            wechat_image: 'fin_photo/wechat/maliangyan.jpg'
          },
          yuhao: {
            name: '余昊',
            nickname: '昊哥',
            duty: '<p>新项目申请</p><p>财务法务行政一切问题</p>',
            time: '',
            email: 'yuhao@baicizhan.com',
            qq: '',
            avatar: 'fin_photo/yuhao.jpg',
            wechat_image: 'fin_photo/wechat/yuhao.jpeg'
          },
          shuchang: {
            name: '舒畅',
            nickname: 'Susan',
            duty: '<p>财务部所有问题</p>',
            time: '',
            email: 'susan@baicizhan.com',
            qq: '',
            avatar: 'fin_photo/shuchang.jpg',
            wechat_image: 'fin_photo/wechat/shuchang.jpg'
          },
          luoyang: {
            name: '罗阳',
            nickname: '腿儿',
            duty: '<p>工商政府相关事项</p><p>月度财务报表出具</p>',
            time: '',
            email: 'luoyang@baicizhan.com',
            qq: '',
            avatar: 'fin_photo/luoyang.jpg',
            wechat_image: 'fin_photo/wechat/luoyang.jpg'
          },
          cuihaowei: {
            name: '崔浩伟',
            nickname: '',
            duty: '<p>公司税务事项解答、咨询</p><p>外汇合同备案</p>',
            time: '',
            email: 'cuihaowei@baicizhan.com',
            qq: '',
            avatar: 'fin_photo/cuihaowei.jpg',
            wechat_image: ''
          },
        }
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>
